import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
export const Hero: React.FC = () => {
  return <section className="min-h-[90vh] flex items-center justify-center py-16 px-6 lg:px-12 bg-cream" data-id="element-100">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-101">
        <motion.div initial={{
        opacity: 0,
        x: -30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="order-2 lg:order-1 flex justify-center" data-id="element-102">
          <div className="relative" data-id="element-103">
            <div className="absolute inset-0 bg-rose-light transform translate-x-4 translate-y-4 -z-10" data-id="element-104"></div>
            <img src="https://cdn.magicpatterns.com/uploads/iwhp1iUvDARbrUpcU6MuKu/independiente.png" alt="El Hombre Ideal para una Mujer Independiente" className="w-full max-w-md object-cover shadow-xl" data-id="element-105" />
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        x: 30
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut',
        delay: 0.2
      }} className="order-1 lg:order-2 flex flex-col items-start text-left" data-id="element-106">
          <span className="text-rose font-bold tracking-widest uppercase text-xs mb-4" data-id="element-107">
            Nuevo eBook
          </span>
          <h1 className="text-4xl md:text-5xl lg:text-6xl leading-tight mb-6" data-id="element-108">
            El Hombre Ideal <br data-id="element-109" />
            <span className="text-gold" data-id="element-110">para una Mujer Independiente</span>
          </h1>
          <p className="text-lg md:text-xl text-charcoal-light mb-8 font-light leading-relaxed border-l-2 border-rose pl-4" data-id="element-111">
            Para la mujer que ya no necesita que la rescaten{' '}
            <br className="hidden md:block" data-id="element-112" />
            <span className="italic" data-id="element-113">
              (pero sí quiere que la quieran bien).
            </span>
          </p>
          <Button onClick={() => document.getElementById('precio')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-114">
            Descarga tu copia ahora
          </Button>
        </motion.div>
      </div>
    </section>;
};